import "./index.css";
import { clsx } from "clsx";
import type { ElementType } from "react";
import type { ITextProps } from "./types";

export const Text = <T extends ElementType = "span">({
  as,
  size = "md",
  weight = "normal",
  tone,
  className,
  ...props
}: ITextProps<T>) => {
  const Component: ElementType = as ?? "span";

  return (
    <Component
      {...props}
      className={clsx(
        "nuco-text",
        `nuco-text--${size}`,
        weight !== "normal" && `nuco-text--${weight}`,
        tone && `nuco-text--${tone}`,
        className,
      )}
    />
  );
};
